import { render, staticRenderFns } from "./couponDetailList.vue?vue&type=template&id=a3174958&scoped=true&"
import script from "./couponDetailList.vue?vue&type=script&lang=js&"
export * from "./couponDetailList.vue?vue&type=script&lang=js&"
import style0 from "./couponDetailList.vue?vue&type=style&index=0&id=a3174958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3174958",
  null
  
)

export default component.exports